module.exports = __webpack_public_path__ + "static/media/upcoming-bills.b1b7aeff.png";